export const getTeamPlan = team => team?.plan

export const getTeamIsOnTrial = team => {
    if (!team || !team.subscription_status) {
        return null;
    }

    return team.subscription_status === 'trialing';
}